import Statechart from './../statechart.js';
import { createConsoleLogger } from './../utils.js';

let counter = 0;

export function createMessengerConnectionHSM(messengerConn, me, collocutor, edgeConnection) {
  const logger = createConsoleLogger(true, 'IMConnHSM (' + (++counter) + '/' + collocutor.username + '):');
  return Object.assign({}, Statechart(), {
    logger,
    // slots
    login_info: false,
    room: '',
    // machine
    initialState: 'SUPERSTATE',
    states: {
      SUPERSTATE: {
        init: 'OFFLINE',
        entry: function() {
          logger.info('SUPERSTATE entry');
        },
        emit_login: function() {
          logger.info('i want to login... when we are ready');
          this.login_info = ['emit_login'].concat(arguments);
          return 'OPERATIONAL';
        },
        restart: function() {
          logger.info('restart()');
          this.room = '';
          this.login_info = false;
          return 'OPERATIONAL';
        },
        sio_request_error: ({ message }) =>  {
          logger.error('sio_request_error()', message);
          if (message.indexOf('action [login]') !== -1) {
            //todo, all incoming goes to edgeConnection first
          }
        },
        go_to_offline: { target: 'OFFLINE' },
        states: {
          OFFLINE: {
            entry: function() {
              logger.info('OFFLINE entry');
            },
            go_to_operational: { target: 'OPERATIONAL' }
          },
          OPERATIONAL: {
            entry: function() {
              logger.info('OPERATIONAL entry');
              logger.info('login_info', this.login_info);
              if (this.login_info) this.dispatch.apply(this, this.login_info);
            },
            emit_login: function(imChatInfo) {
              this.login_info = ['emit_login'].concat(arguments);
              this.room = imChatInfo.room;
              logger.log('emit_login', this.login_info, imChatInfo, me);
              edgeConnection.send({
                action: 'login',
                room: imChatInfo.room,
                login_info: {
                  uid: me.hash,
                  cwt: me.cwt,
                  client_version: 'ws/1'
                }
              });
              return 'AUTHENTICATING';
            },
            states: {
              AUTHENTICATING: {
                entry: function() { logger.info('AUTHENTICATING entry'); },
                sio_login_error: function({ message }) {
                  messengerConn.onLoginError(message);
                },
                sio_login_success: function(data) {
                  logger.log('got login from server', data);
                  return 'ONLINE';
                },
              },
              ONLINE: {
                entry: function() {
                  logger.log('ONLINE entry');
                  messengerConn.onHsmOnlineEnter();
                  edgeConnection.send({ action: 'get_history', room: this.room });
                },
                exit: function() {
                  logger.log('ONLINE exit');
                  messengerConn.onHsmOnlineExit();
                },
                emit_sendMessage: function(message) { edgeConnection.send({ action: 'send_message', room: this.room, message }); },
                sio_history: function({ messages }) { messengerConn.onMessagesList(messages); },
                sio_message: function({ message }) { messengerConn.onNewMessage(message); },
                sio_topic: function() {},
                sio_permissions_on_send_message: function() {},
                sio_join: function({ user, room }) { messengerConn.onPerformerJoin(); },
                sio_leave: function({ user, room }) { messengerConn.onPerformerLeave(); }
              }
            }
          }
        }
      }
    }
  });
}
